import React, { Component } from 'react';
import { Redirect, Link, history } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';

import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewOkr extends Component {
	constructor(props) {
		super(props);
		var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
		this.state = {
			apiUrl: this.decryptconfigdata('apiUrl'),
			userId: has_local_data ? localdata.user_id : '',
			userAuthKey: has_local_data ? localdata.user_key : '',
            okrDetail:[],
	}
    }

	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	componentDidMount() {
        this.viewokr(this.props.match.params.id);
		}
    viewokr(okrId){
        fetch(this.state.apiUrl + '/OkrRest/getOkrDetail/userAuthKey/' + this.state.userAuthKey +'/okrId/' + okrId, {
            method: 'POST',
            dataType: 'json',
        })
       .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
                this.setState({okrDetail:findresponse});
            });
    }
    goBack() {
        window.history.back();
    }


	render() {
		if (this.state.redirect) {
			return (
				<Redirect to={'/login'} />
			)
		}
		return (
			<div>
                    <Header brecum_name="ER" brecum_page="View OKR"/>
                    <div class="right_col">
					<section class="intranet_body">
                            {/*<div class="title mob"><HeaderMob page_name={this.state.page_name}/></div>*/}
                            <div class="okr-singlebox">
                                <div class="head">
                                    <div class="back-area">
                                        <a onClick={() => this.goBack()}>
                                            <span>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.6668 8H3.3335" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.00016 12.6666L3.3335 7.99992L8.00016 3.33325" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
							</span>
                                            Back                                
                                        </a>
						</div>
                                    <div class="right-content">
                                        <span class="year">OKR {this.state.okrDetail.objective_year_quarter}</span>
                                        <span class="name">{this.state.okrDetail.oname}</span>
							</div>
						</div>
                                <div class="full-keyresult">
                                    <div class="single-key-result">
                                        <div class="left-text col-md-11">
                                            <div class="obj-cls">
                                                {this.state.show_obj_inline_box ?<input type="text" class={this.state.show_keyRes_errors && this.state.show_keyRes_errors['objective'] ?"inline-txt-error": "inline-txt"} autoFocus value={this.state.okrDetail.objective} maxlength={this.state.maxLength} onKeyUp={(e)=>this.showTextLimit(e,'objective')} onChange={(e)=>this.changeFieldValue(e,'objective')} /> :this.state.okrDetail.objective}
									</div>
								</div>
							</div>
                                    <div class="child-key-result">
                                    {this.state.okrDetail && this.state.okrDetail.hasOwnProperty('keyresults')?
                                    this.state.okrDetail.keyresults.map((data, key) =>
                                        <div class="single-child-key">
                                        {console.log(312,this.state.okrDetail)}
                                            <div class="inner-single-child changerow">
                                                <div class="left-text">
                                                    <span class="dot"></span>
                                                    <div class="only-text">
                                                    {data.show_div ? 
                                                        data.keyresult 
                                                        :
                                                        this.state.show_keyRes_errors && this.state.show_keyRes_errors[key] ?
                                                        <input type="text" class="keyres-txt-error" autoFocus value={data.keyresult} onChange={(e)=>this.changeFieldValue(e,'keyresult',key)} />
                                                        :
                                                        <input type="text" class="keyres-txt" autoFocus value={data.keyresult} maxlength={this.state.maxLength} onKeyUp={(e)=>this.showTextLimit(e,'keyresult',key)} onChange={(e)=>this.changeFieldValue(e,'keyresult',key)} />
							}
                                                        {data.show_div ?<span class="xtra-text">{data.initiative ? "("+data.init_count +" initiative)":""}</span>:""}
							</div>
						</div>
										</div>
                                            <div class="full-initiative">
                                            {data.initiative.length > 0 ?
                                            data.initiative.map((item,k)=>
                                                item.hasOwnProperty('show_div') ?
                                                <div class="single-initiative">
                                                    <div class="left-text">
                                                        <span class="dot"></span>
                                                        <div class="only-text">
                                                        {item.show_div ? 
                                                            item.init_txt 
                                                            :
                                                            this.state.show_init_errors && this.state.show_init_errors[key] ?
                                                            <input type="text" class="inline-txt-error" autoFocus value={item.init_txt} onChange={(e)=>this.changeFieldValue(e,'initiative',key,k)} />
                                                            :
                                                            <input type="text" class="inline-txt" autoFocus value={item.init_txt} maxlength={this.state.maxLength} onKeyUp={(e)=>this.showTextLimit(e,'initiative',key,k)} onChange={(e)=>this.changeFieldValue(e,'initiative',key,k)} />
												}
										</div>
									</div>
                                                </div>:"")
                                                :""}
									</div>
								</div>
                                        ):""}
							</div>
						</div>
									</div>
					</section>
				</div>
                </div>)
	}
}

export default ViewOkr;


// WEBPACK FOOTER //
// ./src/components/okr/viewokr.js